import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors, withFetch } from '@angular/common/http';
import { provideNativeDateAdapter } from '@angular/material/core';
import { TranslateService, TranslateLoader, TranslateCompiler, TranslateParser, TranslateStore, TranslateDefaultParser, TranslateNoOpCompiler, MissingTranslationHandler, DefaultMissingTranslationHandler } from '@ngx-translate/core';
import { MultiTranslateLoader } from './shared/services/multi-translate-loader.service';

import { routes } from './app.routes';
import { authInterceptor } from './interceptors/auth.interceptor';
import { loaderInterceptor } from './interceptors/loader.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([loaderInterceptor, authInterceptor]),
      withFetch()
    ),
    provideNativeDateAdapter(),
    // Configure ngx-translate with module-wise loading
    TranslateStore,
    {
      provide: TranslateParser,
      useClass: TranslateDefaultParser
    },
    {
      provide: TranslateCompiler,
      useClass: TranslateNoOpCompiler
    },
    {
      provide: MissingTranslationHandler,
      useClass: DefaultMissingTranslationHandler
    },
    {
      provide: TranslateLoader,
      useClass: MultiTranslateLoader
    },
    TranslateService
  ]
};
